// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bar-options .btn.-medium{margin-right:0;padding:9px 24px}", "",{"version":3,"sources":["webpack://./resources/assets/js/components/modals/ModalCallToActionAssinatura.vue"],"names":[],"mappings":"AACA,0BAEE,cAAa,CADb,gBACF","sourcesContent":["\n.bar-options .btn.-medium\n  padding 9px 24px\n  margin-right 0\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
